module.exports = __webpack_public_path__ + "static/media/step04.9718f202.png";